import { SelectorDetector } from './SelectorDetector'

/**
 * Evalutes page for presence of various
 * trackable selectors. Can be used to detect
 * Wordpress plugins, frameworks, etc.
 */
export class Tracker {
  readonly presentTrackables: Array<string> = []

  constructor(
    readonly trackables: Array<ITrackable>,
    readonly _document: Document = document
  ) {
    this.trackables.forEach((trackable) => {
      const selectorDetector = (this[trackable.name] = new SelectorDetector(
        trackable.selectors,
        _document
      ))
      if (selectorDetector.present) {
        this.presentTrackables.push(trackable.name)
      }
    })
  }
}

export interface ITrackable {
  name: string
  selectors: Array<string>
}
